import { render } from "./userDetailedView.vue?vue&type=template&id=6a9a22ff&scoped=true"
import script from "./userDetailedView.vue?vue&type=script&lang=js"
export * from "./userDetailedView.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./userDetailedView.vue?vue&type=style&index=0&id=6a9a22ff&lang=scss&module=true"
cssModules["$style"] = style0
import "./userDetailedView.vue?vue&type=style&index=1&id=6a9a22ff&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-6a9a22ff"]])

export default __exports__